import React from 'react';
import styled from 'styled-components';

import { Button } from '@rover/kibble/core';
import { MQ } from '@rover/kibble/styles';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 20px 20px;

  ${MQ.NOT_XS.toString()} {
    justify-content: flex-end;
    padding: 0;
  }

  ${MQ.XXS.toString()} {
    padding: 0 20px 5px;
  }
`;
export type Props = {
  submitButtonText?: React.ReactNode;
  submitButtonDisabled?: boolean;
  onClickSubmit?: ((arg0: unknown) => void) | null | undefined;
  cancelButtonText?: string | null | undefined;
  onClickCancel?: (() => void) | null | undefined;
};

const DialogModalButtons = ({
  cancelButtonText,
  submitButtonText,
  onClickCancel,
  onClickSubmit,
  submitButtonDisabled = false,
}: Props): JSX.Element => {
  const setMarginLeft = () => {
    /*
    If the modal has two buttons, the second one should have 5x margin-left.
    However, if there's only one, it should not have any margin, it looks off-centre on mobile.
    */
    if (cancelButtonText && submitButtonText) {
      return '5x';
    }
    return '0x';
  };

  return (
    <Wrapper>
      {cancelButtonText && onClickCancel && (
        <Button onClick={onClickCancel} data-qa-id="modal-button-cancel" width={['100%', 'auto']}>
          {cancelButtonText}
        </Button>
      )}
      {submitButtonText && onClickSubmit && (
        <Button
          onClick={onClickSubmit}
          variant="primary"
          disabled={submitButtonDisabled}
          data-qa-id="modal-button-submit"
          marginLeft={setMarginLeft()}
          width={['100%', 'auto']}
        >
          {submitButtonText}
        </Button>
      )}
    </Wrapper>
  );
};

export default DialogModalButtons;
